import React, { useEffect } from 'react';
import { useChatSocket } from '../../context/ChatSocketContext';
import { useChatUI } from '../../context/ChatUIContext';
import { useNotification } from '../../context/NotificationContext';
import { useAuth } from '../../hooks/useAuth';

export const GlobalChatListener: React.FC = () => {
  const { socket } = useChatSocket();
  const { activeUser, openChat } = useChatUI();
  const { showNotification } = useNotification();
  const { user: currentUser } = useAuth();

  useEffect(() => {
    if (!socket || !currentUser) return;

    const handleNewMessage = (message: any) => {
      // Ignorer si le message vient de soi-même
      if (message.senderId === currentUser.id) return;

      // Si le chat est déjà ouvert avec cet utilisateur, on ne montre pas de notification globale
      if (activeUser?.id === message.senderId) return;

      // Sinon, on affiche une notification interactive
      const senderName = message.sender ? `${message.sender.prenom} ${message.sender.nom}` : 'Un collaborateur';
      
      showNotification({
        type: 'info',
        title: 'Nouveau message',
        message: `${senderName} : ${message.content.substring(0, 50)}${message.content.length > 50 ? '...' : ''}`,
        position: 'bottom-right',
        duration: 8000,
        minimizeOnExpire: true, // Nouvelle option activée
        onClick: () => {
          openChat({
            id: message.senderId,
            prenom: message.sender?.prenom || 'Collab',
            nom: message.sender?.nom || '',
            photoProfil: message.sender?.photoProfil
          });
        }
      });
    };

    socket.on('new_direct_message', handleNewMessage);

    return () => {
      socket.off('new_direct_message', handleNewMessage);
    };
  }, [socket, activeUser, currentUser, showNotification, openChat]);

  return null; // Composant invisible (écouteur seulement)
};
